import ConjuntoService from "./ConjuntoService";
import TabladoService from "./TabladoService";
import PencaService from "./PencaService";
import ConcursoService from "./ConcursoService";
import UsuarioService from "./UsuarioService";
import BannerService from "./BannerService";
import ModeracionService from "./ModeracionService";
import FeedbackService from "./FeedbackService";
import EventoService from "./EventoService";

const Servicios = {
  ...ConjuntoService,
  ...TabladoService,
  ...PencaService,
  ...ConcursoService,
  ...UsuarioService,
  ...BannerService,
  ...ModeracionService,
  ...FeedbackService,
  ...EventoService
};
export default Servicios;
